import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import InputGroup from '../../../../../components/global/InputGroup';
import { getAsset } from '../../../../../util/assets';
import Button from '../../../../../components/global/Button';
import Spinner from '../../../../../components/global/Spinner';

const propTypes = {
  values: PropTypes.shape({
    email: PropTypes.string,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  onInitiateEmailAuth: PropTypes.func.isRequired,
  onBackToPhone: PropTypes.func.isRequired,
};

const AuthModeEmailLink = ({
  values,
  onChange,
  loading,
  onInitiateEmailAuth,
  onBackToPhone,
}) => {
  return (
    <Fragment>
      <InputGroup
        id="email"
        type="email"
        name="email"
        required
        addon={<img alt="" src={getAsset('/shutterbug/icons/email.svg')} />}
        placeholder="Your email address"
        value={values.email}
        onChange={({ target }) => onChange('email', target.value)}
        wrapperClassName="mt-4 mb-2"
      />
      <Button
        type="submit"
        className="btn-block mt-4"
        disabled={loading || values.email === ''}
        onClick={onInitiateEmailAuth}
      >
        {loading ? <Spinner size="xs" light /> : 'Verify via Email'}
      </Button>

      <div className="toggle-auth-mode mt-4">
        <Button btnStyle="link" onClick={onBackToPhone}>
          &larr; Back to phone or email sign in
        </Button>
      </div>
    </Fragment>
  );
};

AuthModeEmailLink.propTypes = propTypes;

export default AuthModeEmailLink;
